EntidadService.$inject = ['$resource'];
export default function EntidadService($resource) {
    var urlBase = Sigo.var.path + '/api/v1' + '/entidades' + '/:rol';

    return $resource(urlBase, {
            rol: '@rol'
        }, {}
    );
}
